function knownSlugs(directions) {
  const known = new Set()
  ;(directions || []).forEach((direction) => {
    if (direction && direction.slug) known.add(direction.slug)
    ;(direction && direction.children ? direction.children : []).forEach((child) => {
      if (child && child.slug) known.add(child.slug)
    })
  })
  return known
}

export function findDirection(directions, slug) {
  let found = null
  ;(directions || []).forEach((direction) => {
    if (found || !direction) return
    if (direction.slug === slug) {
      found = direction
      return
    }
    ;(direction.children || []).forEach((child) => {
      if (!found && child && child.slug === slug) found = child
    })
  })
  return found
}

export function directionSlugFromField(raw) {
  if (raw == null || raw === '') return ''
  if (typeof raw === 'string') {
    return raw.split('?')[0].split('#')[0].split('/').filter(Boolean).pop() || ''
  }
  return raw.slug || ''
}

export function directionSlugsFromServices(services) {
  const slugs = []
  const seen = new Set()
  ;(services || []).forEach((service) => {
    const direction = service && service.direction
    const slug = typeof direction === 'string' ? direction : direction && direction.slug
    if (!slug || seen.has(slug)) return
    seen.add(slug)
    slugs.push(slug)
  })
  return slugs
}

export function readSpecialists(body) {
  if (!body) return []
  if (Array.isArray(body)) return body
  if (Array.isArray(body.specialists)) return body.specialists
  if (Array.isArray(body.data)) return body.data
  if (Array.isArray(body.data && body.data.specialists)) return body.data.specialists
  return []
}

function specialistMatches(specialists, doctorId) {
  if (!Array.isArray(specialists)) return false
  return specialists.some((spec) => spec && String(spec.id) === String(doctorId))
}

export function resolveFormDirection(asPath, directions, cmsSlug) {
  const known = knownSlugs(directions)
  if (cmsSlug && known.has(cmsSlug)) return cmsSlug
  const path = String(asPath || '/').split('?')[0].split('#')[0]
  const parts = path.split('/').filter(Boolean)
  for (let i = parts.length - 1; i >= 0; i--) {
    if (known.has(parts[i])) return parts[i]
  }
  return ''
}

export function compatibleDirectionCandidates(cmsSlug, serviceSlugs, pathSlug) {
  const slugs = []
  const push = (slug) => {
    if (slug && slugs.indexOf(slug) === -1) slugs.push(slug)
  }
  push(cmsSlug)
  ;(serviceSlugs || []).forEach(push)
  push(pathSlug)
  return slugs
}

export function pickCompatibleSpecialist({
  formDoctor,
  pageSpecialists,
  directionSpecialists,
  fillFromSpecialists,
}) {
  const list = Array.isArray(directionSpecialists) ? directionSpecialists : []
  const match = (id) => list.find((spec) => spec && String(spec.id) === String(id))

  if (formDoctor) return match(formDoctor) || null
  if (!fillFromSpecialists) return null

  const pageIds = pageSpecialists || []
  if (pageIds.length) {
    for (let i = 0; i < pageIds.length; i++) {
      const found = match(pageIds[i])
      if (found) return found
    }
    return null
  }

  return list[0] || null
}

export async function findCompatibleDirection(directions, slugs, doctorId, loadSpecialists) {
  const known = knownSlugs(directions)
  const candidates = []
  ;(slugs || []).forEach((slug) => {
    if (slug && known.has(slug) && candidates.indexOf(slug) === -1) candidates.push(slug)
  })
  if (!candidates.length || doctorId == null || doctorId === '') return ''

  for (let i = 0; i < candidates.length; i++) {
    const slug = candidates[i]
    try {
      const specialists = await loadSpecialists(slug)
      if (specialistMatches(specialists, doctorId)) return slug
    } catch (error) {}
  }
  return ''
}
